export default __webpack_public_path__ + "static/media/48t.b8417cce.jpg";